import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import RoleGate from './components/RoleGate';
import Shell from './components/Shell';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Sales from './pages/Sales';
import Customers from './pages/Customers';
import Inventory from './pages/Inventory';
import Reports from './pages/Reports';
import Users from './pages/Users';
import CatalogBuilder from './pages/CatalogBuilder';
import PublicCatalog from './pages/PublicCatalog';

const App = () => (
    <BrowserRouter>
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/catalogo" element={<PublicCatalog />} />
            <Route path="/" element={<RoleGate><Shell /></RoleGate>}>
                <Route index element={<Dashboard />} />
                <Route path="ventas" element={<Sales />} />
                <Route path="clientes" element={<Customers />} />
                <Route path="inventario" element={<RoleGate allow={['admin']}><Inventory /></RoleGate>} />
                <Route path="catalogo-admin" element={<RoleGate allow={['admin']}><CatalogBuilder /></RoleGate>} />
                <Route path="reportes" element={<RoleGate allow={['admin']}><Reports /></RoleGate>} />
                <Route path="usuarios" element={<RoleGate allow={['admin']}><Users /></RoleGate>} />
            </Route>
        </Routes>
    </BrowserRouter>
);

export default App;
